// frontend/src/pages/DeliveryList.tsx
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { DeliveryApi } from "../lib/api";
import { Link } from "react-router-dom";

const stateColors: Record<string, string> = {
  draft: "bg-gray-100 text-gray-700",
  confirmed: "bg-blue-100 text-blue-700",
  assigned: "bg-yellow-100 text-yellow-700",
  done: "bg-green-100 text-green-700",
  cancel: "bg-red-100 text-red-700",
};

export default function DeliveryList() {
  const qc = useQueryClient();
  const { data: pickings, isLoading } = useQuery({ queryKey: ["deliveries"], queryFn: () => DeliveryApi.list() });
  const confirmMut = useMutation({ mutationFn: DeliveryApi.confirm, onSuccess: () => qc.invalidateQueries({ queryKey: ["deliveries"] }) });
  const doneMut = useMutation({ mutationFn: DeliveryApi.done, onSuccess: () => qc.invalidateQueries({ queryKey: ["deliveries"] }) });

  if (isLoading) return <p className="text-gray-500">Loading deliveries...</p>;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Deliveries</h1>
        <Link to="/deliveries/new" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">+ New Delivery</Link>
      </div>
      <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="text-left px-4 py-3 font-medium text-gray-600">Reference</th>
              <th className="text-left px-4 py-3 font-medium text-gray-600">Partner</th>
              <th className="text-left px-4 py-3 font-medium text-gray-600">Origin</th>
              <th className="text-center px-4 py-3 font-medium text-gray-600">State</th>
              <th className="text-right px-4 py-3 font-medium text-gray-600">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {pickings?.map((p: any) => (
              <tr key={p.id} className="hover:bg-gray-50">
                <td className="px-4 py-3 font-medium">{p.name}</td>
                <td className="px-4 py-3 text-gray-600">{p.partner_id ?? "—"}</td>
                <td className="px-4 py-3 text-gray-500 text-xs">{p.origin ?? "—"}</td>
                <td className="px-4 py-3 text-center">
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${stateColors[p.state] ?? ""}`}>{p.state}</span>
                </td>
                <td className="px-4 py-3 text-right space-x-2">
                  {p.state === "draft" && <button onClick={() => confirmMut.mutate(p.id)} className="text-blue-600 hover:text-blue-800 text-xs font-medium">Confirm</button>}
                  {p.state === "confirmed" && <button onClick={() => doneMut.mutate(p.id)} className="text-green-600 hover:text-green-800 text-xs font-medium">Done</button>}
                </td>
              </tr>
            ))}
            {(!pickings || pickings.length === 0) && <tr><td colSpan={5} className="px-4 py-8 text-center text-gray-400">No deliveries found</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
